import React from "react";
import { Action, Dispatch } from "redux";
import { Environments, GetScheduleDetails } from "@emisgroup/cohort-builder-kit";
import { ProgressSpinnerSlice } from "../../../../ProgressSpinner/Index";
import { CreateScheduleSlice } from "../../CreateSchedule/redux";
import { ACTIVE, INACTIVE } from "../../Helper/Constants";
import { INVALID, VALID } from "../../../OutputConfig/Constant";
import { handleException } from "../../../../../ErrorMessages/helper";
import "../../../SchedulingConfiguration/ScheduleInstanceTable/Style.scss";

/**
 * Method for fetching the service
 */
export const GetScheduleList = async (
  dispatch: Dispatch<Action>,
  // eslint-disable-next-line @typescript-eslint/ban-types
  translate: Function,
  selectedExtractGuid: string,
  env: Environments,
  token: string,
): Promise<void> => {
  try {
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate("LoadingMessage.ScheduleList")));
    const newResponse = await GetScheduleDetails(
      selectedExtractGuid,
      env,
      token
    );

    if (newResponse && newResponse["data"] && newResponse["data"]["payload"]["schedules"]) {
      const list = newResponse["data"]["payload"]["schedules"];
      dispatch(CreateScheduleSlice.actions.setScheduleList(list || []));
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
    }
  } catch (ex) {
    handleException(ex, dispatch, "GetScheduleListErrMsg");
  }
};

/**
* Method to handle styling with respect to active and inactive of the schedule instance
* @param statusType Schedule status
* @returns JSX element
*/
export const getStatus = (statusType: boolean): JSX.Element => {
  const formattedStatus = statusType ? ACTIVE : INACTIVE;
  return <div className={`ebt-schedule-isactive__${formattedStatus}`}>{formattedStatus}</div>;
};

/**
* Method to handle styling with respect to validity of the schedule
* @param statusType Schedule status
* @returns JSX element
*/
export const getValidity = (statusType: boolean): JSX.Element => {
  const formattedStatus = statusType ? VALID : INVALID;
  return <div className={`ebt-schedule-validity__${formattedStatus}`}>{formattedStatus}</div>;
};

